/* ============================================================================
   assets/customer-detail.js  (NEW STORE — India)

   Same flow as the Costa Rica store:
     Cart  →  /pages/customer-detail (this form)  →  Shopify checkout (pre-filled)

   - Validates the form; the button stays disabled until everything is valid.
   - Builds a cart permalink (/cart/variant:qty,...?checkout[...]=...) so
     checkout opens with the delivery address already filled in.
     (Contact — email/phone — is asked by Shopify checkout itself.)
   - Extra info (marketing checkbox, protection plans chosen on the cart page)
     is passed as cart attributes → visible in Admin → Orders → Additional details.
   - "Save this information for next time" stores the details in this browser
     and fills them in automatically on the next visit.
   ========================================================================== */

(function () {
  'use strict';

  var config = window.CustomerDetailConfig || {};
  var form = document.getElementById('customer-detail-form');
  if (!form) return;

  var COUNTRY_CODE = 'IN';
  var PHONE_PREFIX = '+91';
  var STORAGE_KEY = 'customerDetailSaved';

  var submitBtn = document.getElementById('customer-detail-submit');
  var submitLabel = submitBtn.querySelector('.customer-detail__submit-label');
  var submitSpinner = submitBtn.querySelector('.customer-detail__submit-spinner');
  var formErrorsBox = document.getElementById('form-errors');

  var fields = {
    firstName: document.getElementById('firstName'),
    lastName:  document.getElementById('lastName'),
    address1:  document.getElementById('address1'),
    address2:  document.getElementById('address2'),
    city:      document.getElementById('city'),
    state:     document.getElementById('state'),
    pinCode:   document.getElementById('pinCode'),
    phone:     document.getElementById('phone')
  };
  var saveInfo = document.getElementById('saveInfo');

  // -------------------------- 1. Boot --------------------------------------
  restoreSavedInfo();
  wireDigitsOnly(fields.phone);
  wireDigitsOnly(fields.pinCode);
  wireValidationListeners();
  wirePinLookup();
  initAddressSuggestions();
  form.addEventListener('submit', onSubmit);
  revalidate();

  // Fill a field and let validation know it changed
  function setValue(el, value) {
    if (!el || value === undefined || value === null) return;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    validateField(el, false);
  }

  // Pick the State option by name (e.g. "Gujarat") or by code (e.g. "GJ")
  function selectState(nameOrCode) {
    if (!nameOrCode || !fields.state) return false;
    var wanted = String(nameOrCode).trim().toLowerCase();
    var opts = fields.state.options;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].value && (opts[i].text.toLowerCase() === wanted || opts[i].value.toLowerCase() === wanted)) {
        fields.state.value = opts[i].value;
        fields.state.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  // -------------------- PIN code → City + State (India Post) ---------------
  // Free service, no key needed. If it fails, the customer just types manually.
  function wirePinLookup() {
    var pinHint = document.getElementById('pinCode-hint');
    var lastPin = '';
    if (!fields.pinCode) return;

    fields.pinCode.addEventListener('input', function () {
      var pin = fields.pinCode.value.trim();
      if (!/^[1-9][0-9]{5}$/.test(pin) || pin === lastPin) return;
      lastPin = pin;
      if (pinHint) pinHint.textContent = 'Checking PIN code…';

      fetch('https://api.postalpincode.in/pincode/' + pin)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (pin !== fields.pinCode.value.trim()) return;   // customer changed it meanwhile
          var res = data && data[0];
          var po = res && res.Status === 'Success' && res.PostOffice && res.PostOffice[0];
          if (!po) {
            if (pinHint) pinHint.textContent = 'PIN code not found — please check it.';
            return;
          }
          if (!fields.city.value.trim() || fields.city.dataset.auto === '1') {
            setValue(fields.city, String(po.District || '').trim());
            fields.city.dataset.auto = '1';
          }
          selectState(po.State);
          if (pinHint) pinHint.textContent = String(po.District || '').trim() + ', ' + String(po.State || '').trim();
        })
        .catch(function () {
          if (pinHint) pinHint.textContent = '';
        });
    });

    // If the customer types the city themselves, don't overwrite it later
    fields.city.addEventListener('keydown', function () { fields.city.dataset.auto = '0'; });
  }

  // -------------------- Address suggestions (Google Places) ----------------
  // Only runs when a Google Maps API key is set in the section settings.
  function initAddressSuggestions() {
    var key = config.googleMapsKey;
    var input = fields.address1;
    var list = document.getElementById('address-suggestions');
    if (!key || !input || !list) return;

    var places = null;          // Google Places library
    var mode = 'new';           // 'new' = Places API (New), 'legacy' = older Places API, 'off'
    var sessionToken = null;
    var suggestions = [];       // [{ main, rest, pick() }]
    var activeIndex = -1;
    var debounceTimer = null;
    var requestId = 0;
    var legacyService = null;
    var legacyDetails = null;

    loadGoogle(key).then(function (lib) {
      places = lib;
    }).catch(function (err) {
      console.warn('[customer-detail] Address suggestions unavailable:', err);
    });

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (!places || mode === 'off' || q.length < 3) { hideList(); return; }
      debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (list.hidden || !suggestions.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Enter' && activeIndex >= 0) { e.preventDefault(); choose(activeIndex); }
      else if (e.key === 'Escape') { hideList(); }
    });

    document.addEventListener('click', function (e) {
      if (e.target !== input && !list.contains(e.target)) hideList();
    });

    function fetchSuggestions(q) {
      if (mode === 'new') fetchNew(q);
      else if (mode === 'legacy') fetchLegacy(q);
    }

    // ---- Places API (New) ----
    function fetchNew(q) {
      if (!places.AutocompleteSuggestion) { mode = 'legacy'; fetchLegacy(q); return; }
      if (!sessionToken) sessionToken = new places.AutocompleteSessionToken();
      var thisRequest = ++requestId;
      places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: q,
        includedRegionCodes: ['in'],
        sessionToken: sessionToken
      }).then(function (res) {
        if (thisRequest !== requestId) return;   // an older reply — ignore
        suggestions = (res.suggestions || []).filter(function (s) { return s.placePrediction; })
          .map(function (s) {
            var p = s.placePrediction;
            return {
              main: p.mainText ? p.mainText.toString() : p.text.toString(),
              rest: p.secondaryText ? p.secondaryText.toString() : '',
              pick: function (done) {
                var place = p.toPlace();
                place.fetchFields({ fields: ['addressComponents'] })
                  .then(function () { done(place.addressComponents || []); })
                  .catch(function (err) { console.warn('[customer-detail] Place details failed:', err); done(null); });
              }
            };
          });
        renderList();
      }).catch(function (err) {
        // Key does not have Places API (New) → switch to the older Places API
        console.warn('[customer-detail] Places API (New) not available, trying older Places API.', err && err.message);
        mode = 'legacy';
        sessionToken = null;
        fetchLegacy(q);
      });
    }

    // ---- Older Places API (works with keys that only have "Places API") ----
    function fetchLegacy(q) {
      if (!places.AutocompleteService) { mode = 'off'; hideList(); return; }
      if (!legacyService) {
        legacyService = new places.AutocompleteService();
        legacyDetails = new places.PlacesService(document.createElement('div'));
      }
      if (!sessionToken) sessionToken = new places.AutocompleteSessionToken();
      var thisRequest = ++requestId;
      legacyService.getPlacePredictions({
        input: q,
        componentRestrictions: { country: 'in' },
        sessionToken: sessionToken
      }, function (predictions, status) {
        if (thisRequest !== requestId) return;
        var OK = places.PlacesServiceStatus ? places.PlacesServiceStatus.OK : 'OK';
        var ZERO = places.PlacesServiceStatus ? places.PlacesServiceStatus.ZERO_RESULTS : 'ZERO_RESULTS';
        if (status === ZERO) { suggestions = []; hideList(); return; }
        if (status !== OK || !predictions) {
          console.warn('[customer-detail] Address suggestions turned off. Google status:', status,
            '— enable "Places API (New)" or "Places API" for this key in Google Cloud.');
          mode = 'off';
          hideList();
          return;
        }
        var token = sessionToken;
        suggestions = predictions.map(function (p) {
          var f = p.structured_formatting || {};
          return {
            main: f.main_text || p.description,
            rest: f.secondary_text || '',
            pick: function (done) {
              legacyDetails.getDetails({
                placeId: p.place_id,
                fields: ['address_components'],
                sessionToken: token
              }, function (place, st) {
                if (st !== OK || !place) { done(null); return; }
                done((place.address_components || []).map(function (c) {
                  return { types: c.types, longText: c.long_name, shortText: c.short_name };
                }));
              });
            }
          };
        });
        renderList();
      });
    }

    function renderList() {
      list.innerHTML = '';
      activeIndex = -1;
      if (!suggestions.length) { hideList(); return; }
      suggestions.forEach(function (s, i) {
        var li = document.createElement('li');
        li.className = 'address-suggestions__item';
        li.id = 'address-suggestion-' + i;
        li.setAttribute('role', 'option');
        var strong = document.createElement('strong');
        strong.textContent = s.main;
        li.appendChild(strong);
        if (s.rest) {
          var span = document.createElement('span');
          span.textContent = s.rest;
          li.appendChild(span);
        }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(i); });
        list.appendChild(li);
      });
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(i) {
      var items = list.querySelectorAll('.address-suggestions__item');
      if (!items.length) return;
      activeIndex = (i + items.length) % items.length;
      items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === activeIndex); });
      input.setAttribute('aria-activedescendant', items[activeIndex].id);
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function hideList() {
      list.hidden = true;
      list.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function choose(i) {
      var s = suggestions[i];
      if (!s) return;
      hideList();
      sessionToken = null;   // a session ends when a place is picked
      s.pick(function (components) {
        if (components) fillFromComponents(components, s.main);
        else setValue(input, s.main || input.value);
      });
    }

    function fillFromComponents(components, fallbackLine) {
      function get(type, short) {
        for (var i = 0; i < components.length; i++) {
          if (components[i].types && components[i].types.indexOf(type) !== -1) {
            return short ? components[i].shortText : components[i].longText;
          }
        }
        return '';
      }

      var line1 = [
        get('subpremise'),
        get('premise'),
        [get('street_number'), get('route')].filter(Boolean).join(' '),
        get('sublocality_level_3'),
        get('sublocality_level_2'),
        get('sublocality_level_1')
      ].filter(Boolean);
      // remove repeats (Google sometimes returns the same name twice)
      line1 = line1.filter(function (v, idx) { return line1.indexOf(v) === idx; });

      setValue(input, line1.join(', ') || fallbackLine || input.value);

      var city = get('locality') || get('administrative_area_level_3') || get('administrative_area_level_2');
      // keep Google's city name; the PIN lookup below must not replace it
      if (city) { setValue(fields.city, city); fields.city.dataset.auto = '0'; }

      if (!selectState(get('administrative_area_level_1'))) {
        selectState(get('administrative_area_level_1', true));
      }

      var pin = get('postal_code');
      if (pin) setValue(fields.pinCode, pin);

      revalidate();
      fields.address2.focus();
    }
  }

  // Loads the Google Maps script once and returns the Places library
  function loadGoogle(key) {
    return new Promise(function (resolve, reject) {
      function ready() {
        google.maps.importLibrary('places').then(resolve, reject);
      }
      if (window.google && window.google.maps && window.google.maps.importLibrary) { ready(); return; }
      window.__customerDetailMapsReady = ready;
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
              '&loading=async&libraries=places&callback=__customerDetailMapsReady';
      s.async = true;
      s.onerror = function () { reject(new Error('Google Maps script failed to load')); };
      document.head.appendChild(s);
    });
  }

  // -------------------------- 2. Validation --------------------------------
  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  }

  function getMessage(el) {
    var v = el.value.trim();
    if (el.required && !v) return 'This field is required.';
    if (!v) return '';

    if (el === fields.phone && !/^[6-9][0-9]{9}$/.test(v)) {
      return 'Enter a valid 10-digit mobile number.';
    }
    if (el === fields.pinCode && !/^[1-9][0-9]{5}$/.test(v)) {
      return 'Enter a valid 6-digit PIN code.';
    }
    return '';
  }

  function validateField(el, showError) {
    var wrapper = el.closest('.form-field');
    var errorEl = document.getElementById(el.id + '-error');
    var message = getMessage(el);

    if (message && showError) {
      if (wrapper) wrapper.classList.add('is-invalid');
      if (errorEl) errorEl.textContent = message;
    } else if (!message) {
      if (wrapper) wrapper.classList.remove('is-invalid');
      if (errorEl) errorEl.textContent = '';
    }
    return !message;
  }

  function isFormValid() {
    return Object.keys(fields).every(function (k) {
      return fields[k] ? validateField(fields[k], false) : true;
    });
  }

  function revalidate() {
    submitBtn.disabled = !isFormValid();
  }

  function wireValidationListeners() {
    Object.keys(fields).forEach(function (k) {
      var el = fields[k];
      if (!el) return;
      el.addEventListener('input', revalidate);
      el.addEventListener('change', revalidate);
      el.addEventListener('blur', function () { validateField(el, true); });
    });
  }

  function wireDigitsOnly(input) {
    if (!input) return;
    input.addEventListener('input', function () {
      var cleaned = this.value.replace(/[^0-9]/g, '');
      if (cleaned !== this.value) this.value = cleaned;
    });
  }

  // -------------------------- 3. Save info (this browser) ------------------
  function restoreSavedInfo() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { saved = null; }
    if (!saved) return;
    Object.keys(fields).forEach(function (k) {
      if (fields[k] && saved[k]) fields[k].value = saved[k];
    });
    if (saveInfo) saveInfo.checked = true;
  }

  function storeInfo() {
    try {
      if (saveInfo && saveInfo.checked) {
        var data = {};
        Object.keys(fields).forEach(function (k) {
          if (fields[k]) data[k] = fields[k].value.trim();
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) { /* storage blocked — ignore */ }
  }

  // -------------------------- 4. Submit ------------------------------------
  async function onSubmit(e) {
    e.preventDefault();

    var allValid = true;
    Object.keys(fields).forEach(function (k) {
      if (fields[k] && !validateField(fields[k], true)) allValid = false;
    });
    if (!allValid) {
      showFormError('Please fill in all required fields correctly.');
      return;
    }

    setSubmitting(true);
    clearFormError();
    storeInfo();

    try {
      var url = await buildCheckoutUrl();
      if (url) window.location.href = url;
    } catch (err) {
      console.error('[customer-detail] Submit failed:', err);
      setSubmitting(false);
      showFormError('Could not continue to checkout. Please try again.');
    }
  }

  async function buildCheckoutUrl() {
    var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });

    if (!cart.items || !cart.items.length) {
      window.location.href = config.cartPath || '/cart';
      return null;
    }

    var items = cart.items
      .map(function (i) { return i.variant_id + ':' + i.quantity; })
      .join(',');

    var parts = [];
    function add(key, value) {
      if (value === null || value === undefined) return;
      var v = String(value).trim();
      if (!v) return;
      parts.push(key + '=' + encodeURIComponent(v));
    }
    function addAttr(key, value) {
      if (value === null || value === undefined) return;
      var v = String(value).trim();
      if (!v) return;
      parts.push('attributes[' + encodeURIComponent(key) + ']=' + encodeURIComponent(v));
    }

    var shippingPhone = PHONE_PREFIX + fields.phone.value.trim();

    // Delivery address
    add('checkout[shipping_address][first_name]', fields.firstName.value);
    add('checkout[shipping_address][last_name]',  fields.lastName.value);
    add('checkout[shipping_address][address1]',   fields.address1.value);
    add('checkout[shipping_address][address2]',   fields.address2.value);
    add('checkout[shipping_address][city]',       fields.city.value);
    add('checkout[shipping_address][province]',   fields.state.value);   // e.g. GJ
    add('checkout[shipping_address][country]',    COUNTRY_CODE);
    add('checkout[shipping_address][zip]',        fields.pinCode.value);
    add('checkout[shipping_address][phone]',      shippingPhone);

    // Extra info → order "Additional details"
    addAttr('Phone', shippingPhone);

    // Keep the existing cart note and attributes
    if (cart.note) add('note', cart.note);
    Object.keys(cart.attributes || {}).forEach(function (k) {
      addAttr(k, cart.attributes[k]);
    });

    // The cart permalink does not carry line item properties, so record the
    // protection plans chosen on the cart page as order attributes instead.
    cart.items.forEach(function (i) {
      var p = i.properties || {};
      if (p._protection_plan) {
        addAttr('Protection plan - ' + i.product_title,
          p._protection_plan + (p._protection_plan_price ? ' (' + p._protection_plan_price + ')' : ''));
      }
    });

    return '/cart/' + items + '?' + parts.join('&');
  }

  // -------------------------- 5. UI helpers --------------------------------
  function setSubmitting(isSubmitting) {
    submitBtn.disabled = isSubmitting;
    submitLabel.hidden = isSubmitting;
    submitSpinner.hidden = !isSubmitting;
  }

  function showFormError(msg) {
    formErrorsBox.textContent = msg;
    formErrorsBox.hidden = false;
    formErrorsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearFormError() {
    formErrorsBox.textContent = '';
    formErrorsBox.hidden = true;
  }
})();
